/**
 * Комментарии строки плана (наша таблица, подпись «supply») и партии (areserv,
 * только чтение) — лента для карточки строки и значок числа для состава партии.
 * Спека `docs/specs/2026-11-04-plan-line-status-design.md`, «Комментарий строки».
 *
 * Своя лента, а не `CommentsList` заказов: та привязана к `OrderComment` и
 * ведёт каждой строкой «в CRM», а у комментария строки плана в areserv места
 * нет вовсе — ссылка вела бы в пустоту.
 */

import { MessageSquare } from "lucide-react";

import { day } from "@/lib/orders";
import type { PlanComment } from "./types";

/** `2026-11-04T09:15:00+03:00` → `04.11.26 09:15`; без времени — только день. */
function когда(at: string | null): string {
  if (!at) return "—";
  const время = /[T ](\d{2}:\d{2})/.exec(at)?.[1];
  return время ? `${day(at)} ${время}` : day(at);
}

export function CommentFeed({ items, empty }: { items: PlanComment[]; empty: string }) {
  if (!items.length) return <div className="text-[12.5px] text-fg-muted">{empty}</div>;
  return (
    <div className="flex flex-col gap-1.5">
      {items.map((c) => (
        <div key={`${c.source}:${c.id}`} className="text-[12.5px]">
          <div className="flex gap-2 text-fg-faint">
            <span className="tnum">{когда(c.at)}</span>
            <span className="truncate">{c.user ?? ""}</span>
            <span className="ml-auto flex-none">{c.source}</span>
          </div>
          <div className="whitespace-pre-wrap break-words text-fg">{c.text}</div>
        </div>
      ))}
    </div>
  );
}

/** Значок в строке состава: виден ВСЕГДА (на планшете наведения нет), число —
 *  если есть что считать, последний комментарий — подсказкой. */
export function CommentCount({ items, onClick }: { items: PlanComment[]; onClick: () => void }) {
  const last = items[0];
  return (
    <button
      type="button"
      onClick={onClick}
      title={last ? `${когда(last.at)} ${last.user ?? ""}: ${last.text}` : "комментариев нет — открыть строку"}
      className={
        "inline-flex items-center gap-0.5 hover:text-accent " + (items.length ? "text-accent" : "text-fg-faint")
      }
    >
      <MessageSquare size={12} aria-hidden />
      {items.length ? <span className="tnum text-[11px]">{items.length}</span> : null}
    </button>
  );
}
